import {
  CURRENT_SESSION_CLEAR_VERSION,
  JWT_CACHE_KEY,
  SESSION_CLEAR_VERSION_KEY,
  USER_CACHE_KEY,
} from '@/shared/consts';

export function performOneTimeSessionClear(): void {
  const storedVersion = localStorage.getItem(SESSION_CLEAR_VERSION_KEY);

  if (storedVersion === CURRENT_SESSION_CLEAR_VERSION) {
    return;
  }

  const hasExistingSession =
    localStorage.getItem(JWT_CACHE_KEY) !== null || localStorage.getItem(USER_CACHE_KEY) !== null;

  if (hasExistingSession) {
    localStorage.removeItem(JWT_CACHE_KEY);
    localStorage.removeItem(USER_CACHE_KEY);

    const isCleared =
      localStorage.getItem(JWT_CACHE_KEY) === null && localStorage.getItem(USER_CACHE_KEY) === null;

    if (isCleared) {
      localStorage.setItem(SESSION_CLEAR_VERSION_KEY, CURRENT_SESSION_CLEAR_VERSION);
      window.location.href = '/login';
    }
    return;
  }

  localStorage.setItem(SESSION_CLEAR_VERSION_KEY, CURRENT_SESSION_CLEAR_VERSION);
}
